var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_384_8664",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_384_8664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8.5C5 7.67157 5.67157 7 6.5 7H25.5C26.3284 7 27 7.67157 27 8.5C27 9.32843 26.3284 10 25.5 10H6.5C5.67157 10 5 9.32843 5 8.5Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5C5 15.6716 5.67157 15 6.5 15H25.5C26.3284 15 27 15.6716 27 16.5C27 17.3284 26.3284 18 25.5 18H6.5C5.67157 18 5 17.3284 5 16.5Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 24.5C5 23.6716 5.67157 23 6.5 23H25.5C26.3284 23 27 23.6716 27 24.5C27 25.3284 26.3284 26 25.5 26H6.5C5.67157 26 5 25.3284 5 24.5Z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.43e738c6ed0f0048b393fba9fb9007d0.svg";
export { ForwardRef as ReactComponent };